/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BoardsWelcome from 'DesignSystem/Svgs/BoardsWelcome/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2BulletListIcon from 'DesignSystem/Svgs/Tysiav2BulletListIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Menu/Expanded/BoardsList/Empty"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Empty.Horizontal"
  data-view-path={viewPath}
 style={{'--mr-1-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--ml-2-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-3-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2BulletListIcon
  viewPath={`${viewPath}/Tysiav2BulletListIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 size="normal"
 marginLeft={dtSpaceXs}
 text="All Boards"
/>
</div>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<BoardsWelcome
  viewPath={`${viewPath}/BoardsWelcome`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceM}
 weight="semibold"
 size="normal"
 text="Boards"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 marginTop={dtSpaceXs}
 textAlign="center"
 text="Boards allow you to create sequential tasks that follows from beginning to completion, passing through different states. All the Boards in your location will show up here."
/>
</div>
{children}
</React.Fragment>)
}